import React, { Component } from 'react';
import { Controlled } from 'react-codemirror2';

import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import './codeMirrorModes';

const defaultOptions = {
  theme: 'material',
  lineNumbers: true,
  lineWrapping: true
};

class CodeMirror extends Component {
  render() {
    const { value, onChange, options, mode = 'javascript' } = this.props;

    return <Controlled options={{ ...defaultOptions, ...options, mode }} value={value} onBeforeChange={onChange} />;
  }
}

export default CodeMirror;
